/**
 * `/auth/error` — shown when the post-login refresh fails. Offers a manual route
 * back to the centralized login.
 */
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { HOME_PATH } from '@/routes/home';

export function AuthError() {
  return (
    <main style={{ padding: '2rem', maxWidth: '32rem', margin: '0 auto' }}>
      <h1>Sign-in problem</h1>
      <p>We couldn’t complete sign-in. Your session may have expired or been declined.</p>
      <button type="button" onClick={() => redirectToCentralizedLogin(HOME_PATH)}>
        Try signing in again
      </button>
    </main>
  );
}
